import React, { useMemo, useState } from "react";

/** Grouped, searchable list of every technique in the active tab's category,
 * each row showing a status dot (ready / coming soon / running). */
function TechniqueLibrary({ items, selectedId, runningId, onSelect }) {
  const [search, setSearch] = useState("");

  const groups = useMemo(() => {
    const filtered = items.filter(
      (a) => !search || a.label.toLowerCase().includes(search.toLowerCase())
    );
    const byGroup = {};
    filtered.forEach((a) => {
      if (!byGroup[a.group]) byGroup[a.group] = [];
      byGroup[a.group].push(a);
    });
    return byGroup;
  }, [items, search]);

  return (
    <div className="technique-library">
      <input
        className="technique-search"
        type="text"
        placeholder="Search techniques..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {Object.entries(groups).map(([group, techniques]) => (
        <div className="technique-group" key={group}>
          <h5>{group}</h5>
          {techniques.map((t) => {
            const isRunning = runningId === t.id;
            const disabled = t.status === "comingSoon";
            return (
              <button
                key={t.id}
                className={`technique-row ${t.id === selectedId ? "active" : ""} ${disabled ? "disabled" : ""}`}
                onClick={() => !disabled && onSelect(t.id)}
                disabled={disabled}
                title={disabled ? "Coming soon" : t.description}
              >
                <span className={`technique-dot ${isRunning ? "running" : t.status}`} />
                <span className="technique-label">{t.label}</span>
                {disabled && <span className="technique-soon">Soon</span>}
              </button>
            );
          })}
        </div>
      ))}
      {Object.keys(groups).length === 0 && <p className="analysis-muted">No techniques match.</p>}
    </div>
  );
}

export default TechniqueLibrary;
